import {WlRadioButton} from "./radioButton.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './radioButton.component';
export default WlRadioButton;

defineWebComponent('wl-radio-button', WlRadioButton);
